<script>
import { prospectComputed, authComputed } from '@state/helpers';
export default {
  components: {},
  props: {},
  data() {
    return {
      numOf: {
        import: 30,
        reachOut: 15,
        followUp: 10,
        convert: 5,
      },
    };
  },
  computed: {
    ...prospectComputed,
    ...authComputed,
    imported() {
      return (this.allProspects.length / this.numOf.import) * 100;
    },
    reachOuts() {
      const numOfProspectsContacted = this.allProspects.reduce(
        (sum, { texts, emails }) =>
          texts.length > 0 || emails.length > 0 ? sum + 1 : sum,
        0
      );
      return (numOfProspectsContacted / this.numOf.reachOut) * 100;
    },
    followUps() {
      const getCampaignIds = () =>
        this.currentUser?.org?.growCampaigns
          ?.map((campaign) => campaign._id)
          .slice(1);
      const prospectsWithSecondCampaign = this.allProspects.filter(
        ({ texts, emails }) => {
          if (texts.length > 0) {
            return texts.some((text) =>
              getCampaignIds()?.includes(text.campaign)
            );
          } else if (emails.length > 0) {
            return emails.some((email) =>
              getCampaignIds()?.includes(email.campaign)
            );
          }
        }
      );
      return (prospectsWithSecondCampaign.length / this.numOf.followUp) * 100;
    },
    converted() {
      const convert = this.allProspects.filter(
        (prospect) => !!prospect.is_converted
      ).length;
      return (convert / this.numOf.convert) * 100;
    },
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div>
    <h5 class="card-title">New Lead Goals</h5>
    <ul>
      <li class="card-prospecting-progress">
        <div :class="['progress-indicator', { complete: imported === 100 }]">
          <BaseIcon name="check" v-if="imported === 100" />
        </div>
        <div class="coloumn">
          Create {{ numOf.import }} Leads
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              :style="`width: ${imported}%`"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </li>
      <li class="card-prospecting-progress">
        <div :class="['progress-indicator', { complete: reachOuts === 100 }]">
          <BaseIcon name="check" v-if="reachOuts === 100" />
        </div>
        <div class="coloumn">
          Send Cold Reach Out to {{ numOf.reachOut }} Leads
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              :style="`width: ${reachOuts}%`"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </li>
      <li class="card-prospecting-progress">
        <div :class="['progress-indicator', { complete: followUps === 100 }]">
          <BaseIcon name="check" v-if="followUps === 100" />
        </div>
        <div class="coloumn">
          Follow-up With {{ numOf.followUp }} Leads
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              :style="`width: ${followUps}%`"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </li>
      <li class="card-prospecting-progress"
        ><div :class="['progress-indicator', { complete: converted === 100 }]">
          <BaseIcon name="check" v-if="converted === 100" />
        </div>
        <div class="coloumn">
          Convert {{ numOf.convert }} Leads to Clients
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              :style="`width: ${converted}%`"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-max-type

.card-title {
  color: $color-black-one;
  font-size: 1.8rem;
  font-weight: bold;
  letter-spacing: -0.25px;
  line-height: 24px;
  margin-bottom: 2rem;
}

ul li {
  color: black;
  display: flex;
  font-size: 1.7rem;
  justify-content: space-between;
  letter-spacing: -0.233333px;
  margin-bottom: 1rem;

  &.card-prospecting-progress {
    background-color: white;
    border: 1px solid $color-light-gray-three;
    border-radius: $base-border-radius-md;
    padding: 0.8rem 1.6rem 1.6rem 0.8rem;

    .coloumn {
      color: $color-black;
      display: flex;
      flex-direction: column;
      font-size: 1.4rem;
      font-weight: 600;
      line-height: 24px;
      width: 87%;
      .progress {
        background-color: rgba($color-primary-one-wo-rgb, 0.3);
        border-radius: 10rem;
        margin-top: 8px;
        .progress-bar {
          background-color: $color-action;
        }
      }
    }
  }
  .progress-indicator {
    align-items: center;
    border: 1px solid $color-light-gray-six;
    border-radius: $border-radius-circle;
    box-sizing: border-box;
    display: flex;
    height: 2.5rem;
    justify-content: center;
    width: 2.5rem;

    &.complete {
      background-color: $color-action;
      border: 1px solid $color-action;

      .fa-check {
        color: white;
        font-size: 1.3rem;
      }
    }
  }
}
</style>
